var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "",
            visible: _vm.dialogTableVisible2,
            width: "22cm",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible2 = $event
            },
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-printer" },
              on: {
                click: function ($event) {
                  return _vm.blPrint()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("button.print")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.getPdf("#pdfDom")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("button.pdf")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "print",
              staticStyle: { position: "relative" },
              attrs: { id: "pdfDom" },
            },
            [
              _c("img", { attrs: { src: "/img/print/bl.png", width: "100%" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "0px",
                    left: "0",
                    color: "#044164",
                    width: "100%",
                    "font-size": "11px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "55px" } },
                    [
                      _c("el-col", { attrs: { span: 6, offset: 18 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.blNo)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 6, offset: 12 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.bkNoS)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "25px", height: "100px" } },
                    [
                      _c("el-col", { attrs: { span: 10, offset: 1 } }, [
                        _vm._v(
                          _vm._s(_vm.blPrintForm.shipper) + "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "20px", height: "100px" } },
                    [
                      _c("el-col", { attrs: { span: 10, offset: 1 } }, [
                        _vm._v(
                          _vm._s(_vm.blPrintForm.consignee) + "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "15px", height: "80px" } },
                    [
                      _c("el-col", { attrs: { span: 10, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.notify)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "22px", height: "60px" } },
                    [
                      _c("el-col", { attrs: { span: 6, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.vvl1) + " "),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.por)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "25px", height: "45px" } },
                    [
                      _c("el-col", { attrs: { span: 6, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.vvl) + " "),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.pol)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "20px", height: "55px" } },
                    [
                      _c("el-col", { attrs: { span: 6, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.pod) + " "),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.del)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "22px", height: "300px" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-top": "15px" },
                          attrs: { span: 4, offset: 1 },
                        },
                        [_vm._v(_vm._s(_vm.blPrintForm.mark) + "\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "15px" },
                          attrs: { span: 11 },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.blPrintForm.casgo) +
                              " "
                          ),
                          _c("br"),
                          _c("br"),
                          _c("br"),
                          _vm._v(
                            "\n            " + _vm._s(_vm.blPrintForm.casgo2)
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.blPrintForm.sayEn) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "20px" },
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "150px" },
                              attrs: { span: 13 },
                            },
                            [_vm._v(_vm._s(_vm.blPrintForm.grossWeight) + " ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: { height: "150px" },
                              attrs: { span: 10 },
                            },
                            [_vm._v(_vm._s(_vm.blPrintForm.cargoSize))]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            attrs: { src: "/img/print/copy.png", width: "80%" },
                          }),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-weight": "500",
                                color: "rgb(51,102,255)",
                              },
                            },
                            [_vm._v(_vm._s(_vm.blPrintForm.today))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "25px", height: "100px" } },
                    [
                      _c("el-col", { attrs: { span: 4, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.freight) + " "),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 7, offset: 1 } }, [
                        _vm._v("  "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 3 },
                        },
                        [_vm._v("  ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 4 },
                        },
                        [_vm._v(" \n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 3 },
                        },
                        [_vm._v(_vm._s(_vm.blPrintForm.ccOf))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "20px", height: "40px" } },
                    [
                      _c("el-col", { attrs: { span: 5, offset: 1 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.prepaidPlace) + " "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "10px" },
                          attrs: { span: 7 },
                        },
                        [_vm._v(_vm._s(_vm.blPrintForm.payablePlace) + " ")]
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 5, offset: 4 } }, [
                        _vm._v(" " + _vm._s(_vm.blPrintForm.blNumber)),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticStyle: { "padding-top": "20px", height: "40px" } },
                    [
                      _c("el-col", { attrs: { span: 8, offset: 3 } }, [
                        _vm._v(_vm._s(_vm.blPrintForm.issueDate) + " "),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8, offset: 3 } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        "padding-top": "50px",
                        "font-size": "9px",
                      },
                    },
                    [
                      _c("el-col", { attrs: { span: 14, offset: 4 } }, [
                        _vm._v(
                          "DELIVERY AGENT:" +
                            _vm._s(_vm.blPrintForm.contactWay) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }